import { login, logout } from '@polleverywhere/slideware-bindings'

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenTo(state, 'session:logout', () => {
      logout()
    })

    dispatcher.listenTo(state, 'session:start', (user) => {
      const page = state.appStates.slideware.get('page')

      // There can be a timing issue during logout route where we the session
      // starts (because the page opened), we destroy the the session (from logout), but then we are here.
      if (!user || !user.isLoggedIn()) {
        return
      }

      if (page !== 'disable_lab_features' && page !== 'liveslide_security') {
        // Delay logging into the native app as this causes a
        // ChunkLoadError when being redirected from web presenter
        setTimeout(() => {
          login(user)
        }, 1000)
      }
    })
  })
}
